export default __webpack_public_path__ + "static/search-bg-0e0529b229b24c086d94823ee66950b1.png";